import * as Sentry from "@sentry/react";
import { createBrowserRouter } from "react-router";

import Layout from "../components/Layout";
import SuperAdminLayout from "../components/Layout/SuperAdminLayout";

import ForgotPassword from "../features/auth/forgotPassword";
import SignIn from "../features/auth/signIn";
import SignUp from "../features/auth/signUp";

import ProtectedRoute from "../features/auth/ProtectedRoute";

import CarrierOffer from "../pages/CarrierOffer";
import CompanyStatistics from "../pages/CompanyStatistics";
import { PublicListing } from "../pages/PublicListing";
// import CompanyUsers from "../pages/CompanyUsers";
import Recipients from "../pages/Recipients";
import Statistics from "../pages/Statistics";
import UserIntegrations from "../pages/UserIntegrations";
import UserSettings from "../pages/UserSettings";
// super-admin
import AddCompany from "../pages/super-admin/AddCompany";
import Company from "../pages/super-admin/Company";
import Dashboard from "../pages/super-admin/Dashboard";

import { AppMainWrapper } from "../components/AppMainWrapper";
import ExcludedRoute from "../features/auth/ExcludedRoute";
import SetPassword from "../features/auth/setPassword";
import JoyrideWrapper from "../hocs/JoyrideWrapper";
import Forbidden from "../pages/Forbidden";
import NotFound from "../pages/NotFound";
import PostRegisterThankYou from "../pages/PostRegisterThankYou";

const sentryCreateBrowserRouter =
	Sentry.wrapCreateBrowserRouterV7(createBrowserRouter);

export const router = sentryCreateBrowserRouter([
	{
		element: <AppMainWrapper />,
		errorElement: <NotFound />,
		children: [
			{
				path: "/forbidden",
				element: <Forbidden />,
			},
			{
				path: "/public-listing",
				element: <PublicListing />,
			},
			{
				element: <ExcludedRoute />,
				children: [
					{
						path: "/login",
						element: <SignIn />,
					},
					{
						path: "/register",
						element: <SignUp />,
					},
					{
						path: "/thank-you",
						element: <PostRegisterThankYou />,
					},
					{
						path: "/forgot-password",
						element: <ForgotPassword />,
					},
					{
						path: "/set-password",
						element: <SetPassword />,
					},
					{
						path: "/offers/emails",
						element: <CarrierOffer />,
					},
				],
			},
			{
				element: <JoyrideWrapper />,
				children: [
					{
						element: (
							<ProtectedRoute roles={["user", "admin", "branch-manager"]} />
						),
						children: [
							{
								element: <Layout />,
								children: [
									{
										path: "/",
										async lazy() {
											let Cargos = await import("../pages/Cargos");
											return {
												Component: Cargos.default,
											};
										},
									},
									{
										path: "/integrations",
										element: <UserIntegrations />,
									},
									{
										path: "/user-data",
										element: <UserSettings />,
									},
									{
										path: "/recipients",
										element: <Recipients />,
									},
									{
										path: "/stats",
										element: <Statistics />,
									},
								],
							},
						],
					},
					{
						element: <ProtectedRoute roles={["admin", "branch-manager"]} />,
						children: [
							{
								element: <Layout />,
								children: [
									{
										path: "/company-stats",
										element: <CompanyStatistics />,
									},
									{
										path: "/company-users",
										async lazy() {
											let CompanyUsers = await import("../pages/CompanyUsers");
											return {
												Component: CompanyUsers.default,
											};
										},
									},
								],
							},
						],
					},
				],
			},
			{
				element: <ProtectedRoute roles={["super-admin"]} />,
				children: [
					{
						element: <SuperAdminLayout />,
						children: [
							{
								path: "/admin",
								element: <Dashboard />,
							},
							{
								path: "/admin/company/:companyId",
								element: <Company />,
							},
							{
								path: "/admin/company/add",
								element: <AddCompany />,
							},
						],
					},
				],
			},
		],
	},
]);
